<template>
<v-container>
  <v-row>

    <v-col cols="6">
      <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_DniWolne_Dodawanie')">Dodaj dzień wolny</v-btn>
    </v-col>
    <v-col cols="6">
      <v-checkbox v-model="showAll" label="Pokaż przeszłe"></v-checkbox>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <v-data-table
          :headers="headers"
          :items="dayoffs"
          :options.sync="options"
          :server-items-length="totalCount"
          :loading="loading"
          :footer-props="{
                        itemsPerPageOptions:[50,100,200,500],
              }"
          class="elevation-1"
      >
        <template v-slot:item="props">
          <tr>
            <td>{{props.item.description}}</td>
            <td>{{getFormattedDate(props.item.startTime,props.item.hours)}}</td>
            <td>{{getFormattedDate(props.item.endTime, props.item.hours)}}</td>
            <td>
              <v-icon small class="mr-2" @click="editDayOff(props.item)" v-if="$can('do','POKO_DniWolne_Dodawanie')" title="Edytuj dzień wolny">fa-edit</v-icon>
              <v-icon small class="mr-2" @click="deleteDayOff(props.item)" v-if="$can('do','POKO_DniWolne_Usuwanie')" title="Usuń dzień wolny">fa-trash</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="showEdit" width="50%" persistent>
        <DayOffEdit v-if="showEdit" :edit="edited" @close="closedEdit"></DayOffEdit>
      </v-dialog>
    </v-col>
  </v-row>
</v-container>
</template>

<script>

import {mapActions} from "vuex";
import * as dayjs from "dayjs";
import swal from "sweetalert";
import {daysOffsService} from "@/services/daysoffs.service";
import DayOffEdit from "@/components/daysoffs/DayOffEdit";

export default {
  name: "ListDaysOffs",
  components: {DayOffEdit},
  data() {
    return {
      loading: false,
      totalCount: 0,
      dayoffs:[],
      edited: null,
      options: {},
      showEdit: false,
      showAll: false,
      headers: [
        {text: 'Opis',  align: 'left', value: 'description'},
        {text: 'Data początek', align: 'left', value: 'startTime'},
        {text: 'Data koniec', align: 'left', value: 'endTime'},
        {text: 'Akcje', align: 'left', value: 'id'},
      ]
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    closedEdit() {
      this.showEdit = false
      this.getData()
    },
    getData() {
      const {page, itemsPerPage} = this.options
      this.loading = true
      daysOffsService.getAll({
        SkipCount: (page - 1) * itemsPerPage,
        MaxResultCount: itemsPerPage,
        ShowAll: this.showAll
      }).then(result => {
        this.dayoffs = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(() => {
        this.showError('Błąd pobierania dni wolnych.')
        this.loading = false
      })
    },
    addNew()
    {
      this.edited = null
      this.showEdit = true
    },
    editDayOff(item)
    {
      this.edited = item
      this.showEdit = true
    },
    getFormattedDate(val, hours) {
      let dj = dayjs(val)
      if (dj != null) {
        if(hours)
          return dj.format("DD-MM-YYYY HH:mm")
        else
          return dj.format("DD-MM-YYYY")

      } else {
        return val
      }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    deleteDayOff(item) {
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć tą wizyte rezerową?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          daysOffsService.deleteDayOff(item.id).then(() => {
            this.getData()
          }).catch(e => {
            if (
                e.response != null &&
                e.response.data != null &&
                e.response.data.error != null
            ) {
              this.error(e.response.data.error.message)
            } else {
              this.error('Błąd usuwania dnia wolnego')
            }
          })
        }
      });

    },
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    showAll: {
      handler() {
        this.getData()
      }
    }
  },
}
</script>

<style scoped>

</style>